<template>
  <nav v-if="prev || next" class="blog-prev-next" aria-label="Article navigation">
    <router-link v-if="prev" :to="`/${prev.slug}/`" class="blog-prev-next__prev">
      <span class="blog-prev-next__label">Previous</span>
      <span class="blog-prev-next__title">{{ prev.title }}</span>
    </router-link>
    <router-link v-if="next" :to="`/${next.slug}/`" class="blog-prev-next__next">
      <span class="blog-prev-next__label">Next</span>
      <span class="blog-prev-next__title">{{ next.title }}</span>
    </router-link>
  </nav>
</template>

<script>
import { getAdjacentPosts } from '@/utils/blog'

export default {
  name: 'BlogPrevNext',
  props: {
    slug: { type: String, required: true },
  },
  computed: {
    prev() {
      return getAdjacentPosts(this.slug).prev
    },
    next() {
      return getAdjacentPosts(this.slug).next
    },
  },
}
</script>
